@if (src) {
  <div class="rebranded-audio-container" (click)="$event.stopPropagation();"
    [ngClass]='{ "bg-white": imageUrl, "tw-rounded-full tw-px-2 tw-py-[3px] tw-h-[48px]": newUI}'>
    @if (imageUrl) {
      <div class="audio-img-container" [ngClass]='{ "tw-w-[42px] tw-h-[42px]": newUI}'>
        <img alt="doctor profile photo" class="audio-img" [ngClass]='{ "tw-w-[42px] tw-h-[42px] tw-mx-0": newUI, "mL5 mR5": !newUI}' src="{{imageUrl}}" />
        @if (!newUI) {
          <img alt="green mic" class="audio-mic" src="/assets/images/mic.svg" />
        }
        @if (newUI) {
          <img alt="orange mic" class="tw-absolute tw-left-[40px] tw-bottom-[14px]" src="/assets/icons/orange-mic.svg"/>
        }
      </div>
    }
    <div class="slider-box" [ngClass]='{ "mL20": imageUrl && !newUI, "tw-bg-transparent tw-ml-2": newUI}'>
      @if (!isPlaying) {
        <div class="text-center play-container" (click)="playAudio();$event.stopPropagation();">
          <em class="cs-icon-play playButton"></em>
        </div>
      }
      @if (isPlaying) {
        <div class="text-center play-container" (click)="pauseAudio();$event.stopPropagation();">
          <em class="cs-icon-pause pauseButton"></em>
        </div>
      }
      <div class="slider-container">
        <input class="slider" #slider="" type="range" min="0" max="100" value="0" step="1" />
        <div class="slider-time">
          @if (loading) {
            <loading [scale]="0.4" margin="-11px"></loading>
          }
          @if (!loading) {
            <div class="font12">{{audioDuration}}</div>
          }
        </div>
      </div>
      @if (internalUser) {
        <div class="speed-control" (click)="togglePlaybackSpeed();$event.stopPropagation();" title="Playback Speed">
          <span class="speed-button">{{playbackSpeed}}x</span>
        </div>
      }
    </div>
  </div>
}